import { Skeleton } from '@/components/ui'
import {
  useAccount,
  useAccountWebsocket,
  useLoadingSummary,
} from '@/modules/account'
import { ChatUsage } from './ChatUsage'
import { LegacyUsage } from './LegacyUsage'
import { TrialUsage } from './TrialUsage'
import { Usage } from './Usage'

export { TrialUsage }

export const AccountBillingUsage = () => {
  const account = useAccount()
  const loading = useLoadingSummary()
  useAccountWebsocket()

  if (loading) {
    return <Skeleton className="h-28 w-full" />
  }

  return (
    <div className="flex flex-col w-full gap-1">
      <p className="text-base font-semibold">{account?.plan}</p>
      <div className="flex flex-col border border-slate-200 bg-slate-50 w-full gap-3 rounded-lg p-2">
        <TrialUsage />
        <Usage />
        <LegacyUsage />
        <ChatUsage />
      </div>
    </div>
  )
}
